import { NgZone, inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';

import { isViewTransitionsEnabled } from '@frontend/vanilla/core';
import { debounceTime, filter, map, raceWith, take, timer } from 'rxjs';
import { of } from 'rxjs';

import { GestureStateService } from './gesture-state.service';

const MAX_ANIMATION_WAIT_TIME = 500;

export const viewTransitionAnimationGuard: CanActivateChildFn = () => {
    if (!isViewTransitionsEnabled()) {
        return of(true);
    }

    const ngZone = inject(NgZone);
    const gestureStateService = inject(GestureStateService);

    return ngZone.runOutsideAngular(() =>
        gestureStateService.isGestureInProgress.pipe(
            debounceTime(0),
            filter((isInProgress) => !isInProgress),
            raceWith(timer(MAX_ANIMATION_WAIT_TIME)),
            take(1),
            map(() => true),
        ),
    );
};
